import { render, staticRenderFns } from "./UploadImageAction.vue?vue&type=template&id=4a4794b5&scoped=true"
import script from "./UploadImageAction.vue?vue&type=script&lang=js"
export * from "./UploadImageAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4794b5",
  null
  
)

export default component.exports